import {css} from 'lit';

    export const style = css`
        :host {
            --toggle__width: var(--sbkToggleSizing3xl);
            --toggle__sizing: var(--sbkToggleSizingXl);
            --toggle__border-radius: 25px;
            --toggle__ball-size: var(--sbkToggleSizingXl);
            --togglePadding: var(--sbkToggleSpacing4xs);

            --toggle__color: var(--_toggle__color, var(--sbkToggleColorFgColorOnLightDefault));
            --toggle__color--hover: var(--_toggle__color--hover, var(--sbkToggleColorFgColorOnDarkHover));
            --toggle__color--disabled-light: var(--_toggle__color--disabled-light, var(--sbkToggleColorFgColorOnLightDisabled));
            --toggle__color--hover-nein: var(--_toggle__color--hover-nein, var(--sbkToggleColorFgColorOnLightHover));
            --toggle__color--light: var(--_toggle__color--light, var(--sbkToggleColorFgColorOnDarkDefault));
            --toggle__color--disabled-dark: var(--_toggle__color--disabled-dark, var(--sbkToggleColorFgColorOnDarkDisabled));

            --toggle__border: var(--_toggle__border, var(--sbkToggleBorderOnLightEnabled));
            --toggle__border--disabled: var(--_toggle__border--disabled, var(--sbkToggleBorderOnLightDisabled));
            --toggle__border--focus: var(--_toggle__border--focus, var(--sbkToggleBorderOnLightFocus));
            --toggle__border--hover: var(--_toggle__border--hover, var(--sbkToggleBorderOnLightHover));

            --toggle__bg: var(--_toggle__bg, var(--sbkToggleColorFgColorOnLightDefault));
            --toggle__bg--hover: var(--_toggle__bg--hover, var(--sbkToggleColorBgColorOnLightHover));
            --toggle__bg--active: var(--_toggle__bg--active, var(--sbkToggleColorBgColorOnLightSelected));
            --toggle__bg--disabled: var(--_toggle__bg--disabled, var(--sbkToggleColorBgColorOnLightDisabled));
            --toggle__bg--focus: var(--_toggle__bg--focus, var(--sbkToggleColorBgColorOnLightFocus));
        }

        .sr-only {
            position: absolute;
            clip: rect(1px, 1px, 1px, 1px);
            padding: 0;
            border: 0;
            height: 1px;
            width: 1px;
            overflow: hidden;
        }

        .switch-toggle__wrapper {
            padding: var(--togglePadding) 0;
        }

        .toggle {
            position: relative;
            display: inline-flex;
            align-items: center;
            min-width: var(--toggle__width);
            height: calc(var(--sbkToggleSizingXl) + var(--togglePadding) + var(--togglePadding));
            border-radius: var(--toggle__border-radius);
            cursor: pointer;
            transition: background-color 0.25s ease-in, border 0.25s ease-in, color 0.25s ease-in;
            border: var(--toggle__border);
            font: var(--sbkToggleTypographySm);
        }

        .toggle::after {
            content: '';
            position: absolute;
            left: var(--togglePadding);
            width: var(--toggle__ball-size);
            height: var(--toggle__ball-size);
            background-color: var(--toggle__bg);
            border-radius: 50%;
            transition: transform 0.25s ease-out, background-color 0.25s ease-out;
        }

        .switch-toggle:checked + .toggle__wrapper .toggle {
            background-color: var(--toggle__bg--active);
            border: var(--toggle__border);
            color: var(--toggle__color--light);
        }

        .switch-toggle:checked + .toggle__wrapper .toggle::after {
            transform: translateX(calc(var(--toggle__width) - var(--toggle__ball-size) - var(--togglePadding) * 2));
            background-color: var(--toggle__color--light);
            margin-left: calc(var(--toggle__ball-size) + var(--togglePadding));
        }

        .switch-toggle:not(:checked) + .toggle__wrapper .toggle {
            border: var(--toggle__border);
            color: var(--toggle__color);
        }

        .switch-toggle:not(:checked) + .toggle__wrapper .toggle::after {
            background-color: var(--toggle__bg--active);
        }

        input[type="checkbox"]:focus-visible + .toggle__wrapper .toggle {
            outline: var(--toggle__border--focus);
            outline-offset: max(2px, 0.15em);
        }

        .toggle.toggle-right {
            justify-content: center;
            padding-right: calc(var(--toggle__ball-size) + var(--togglePadding));
        }

        .toggle.toggle-left {
            justify-content: center;
            padding-left: calc(var(--toggle__ball-size) + var(--togglePadding));
        }

        .toggle.toggle-left::after {
            background-color: var(--toggle__bg);
        }

        .switch-toggle:checked + .toggle__wrapper .toggle.toggle-right::after {
            background-color: var(--toggle__color--light);
        }

        .switch-toggle:not(:checked) + .toggle__wrapper .toggle.toggle-left::after {
            background-color: var(--toggle__color);
        }

        @media (hover: hover) and (pointer: fine) {
        .switch-toggle:not(:checked):hover + .toggle__wrapper .toggle {
            border: var(--toggle__border--hover);
            color: var(--toggle__color--hover-nein);
        }

        .switch-toggle:not(:checked):hover + .toggle__wrapper .toggle__label-text {
            color: var(--toggle__color--hover-nein);
            cursor: pointer;
        }

        .switch-toggle:not(:checked):hover + .toggle__wrapper .toggle::after {
            background-color: var(--toggle__color--hover-nein);
        }

        .switch-toggle:checked:hover + .toggle__wrapper .toggle {
            border: var(--toggle__border--hover);
            color: var(--toggle__color--hover);
            background-color: var(--toggle__bg--active);
        }

        .switch-toggle:checked:hover + .toggle__wrapper .toggle__label-text {
            color: var(--toggle__color--hover-nein);
            cursor: pointer;
        }

        .switch-toggle:checked:hover + .toggle__wrapper .toggle::after {
            background-color: var(--toggle__color--hover);
        }
        }

        :host([disabled]) .switch-toggle + .toggle__wrapper .toggle {
          background-color: var(--toggle__bg--disabled);
          border: var(--toggle__border--disabled);
            color: var(--toggle__color--disabled-light);
            cursor: not-allowed;
        }

        :host([disabled]) .switch-toggle + .toggle__wrapper .toggle__label-text {
            cursor: not-allowed;
        }

        :host([disabled]) .switch-toggle + .toggle__wrapper .toggle::after {
            background-color: var(--toggle__color--disabled-light);
        }

        .toggle__wrapper {
            display: inline-flex;
            align-items: center;
        }

        .toggle__wrapper.label-left {
            flex-direction: row-reverse;
        }

        .toggle__wrapper.label-right {
                overflow-wrap: break-word;

            .toggle__label-text {
                margin-left: var(--sbkToggleSpacingXs);
            }
        }

        .toggle__wrapper.label-left {
                overflow-wrap: break-word;

            .toggle__label-text {
                margin-right: var(--sbkToggleSpacingXs);
            }
        }

        .toggle__wrapper.full {
            display: flex;
            -webkit-box-pack: justify;
            justify-content: space-between;
        }

`;
